window.addEventListener("DOMContentLoaded", configuratorInfo);

function configuratorInfo() {
  const requestFormSubmit = document.getElementById("requestFormSubmit");
  requestFormSubmit.addEventListener("click", validateForm);
}

function checkName(event) {
  var e = event;
  let isNameOk = true;
  document
    .querySelectorAll("#requestConfiguration input[name='request[first_name]']")
    .forEach(function (el) {
      if (!el.value) {
        el.closest(".requestForm__Item").classList.add("error");
        e.preventDefault();
        e.cancelBubble = true;
        e.stopImmediatePropagation();
        e.stopPropagation();
        isNameOk = false;
      } else {
        el.closest(".requestForm__Item").classList.remove("error");
      }
    });
  return isNameOk;
}
function checkLastName(event) {
  var e = event;
  let isLastNameOk = true;
  document
    .querySelectorAll("#requestConfiguration input[name='request[last_name]']")
    .forEach(function (el) {
      if (!el.value) {
        el.closest(".requestForm__Item").classList.add("error");
        e.preventDefault();
        e.cancelBubble = true;
        e.stopImmediatePropagation();
        e.stopPropagation();
        isLastNameOk = false;
      } else {
        el.closest(".requestForm__Item").classList.remove("error");
      }
    });
  return isLastNameOk;
}
function checkEmail(event) {
  var e = event;
  let isEmailOk = true;
  document
    .querySelectorAll("#requestConfiguration input[name='request[email]']")
    .forEach(function (el) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!el.value.match(regex)) {
        el.closest(".requestForm__Item").classList.add("error");
        e.preventDefault();
        e.cancelBubble = true;
        e.stopImmediatePropagation();
        e.stopPropagation();
        isEmailOk = false;
      } else {
        el.closest(".requestForm__Item").classList.remove("error");
      }
    });
  return isEmailOk;
}
function checkPhone(event) {
  var e = event;
  let isPhoneOk = true;
  document
    .querySelectorAll("#requestConfiguration input[name='request[phone]']")
    .forEach(function (el) {
      if (!el.value) {
        el.closest(".requestForm__Item").classList.add("error");
        e.preventDefault();
        e.cancelBubble = true;
        e.stopImmediatePropagation();
        e.stopPropagation();
        isPhoneOk = false;
      } else {
        el.closest(".requestForm__Item").classList.remove("error");
      }
    });
  return isPhoneOk;
}
function checkCountry(event) {
  var e = event;
  let isCountryOk = true;
  document
    .querySelectorAll("#requestConfiguration input[name='request[country]']")
    .forEach(function (el) {
      if (!el.value) {
        el.closest(".requestForm__Item").classList.add("error");
        e.preventDefault();
        e.cancelBubble = true;
        e.stopImmediatePropagation();
        e.stopPropagation();
        isCountryOk = false;
      } else {
        el.closest(".requestForm__Item").classList.remove("error");
      }
    });
  return isCountryOk;
}
function checkProvince(event) {
  var e = event;
  let isProvinceOk = true;
  document
    .querySelectorAll("#requestConfiguration input[name='request[province]']")
    .forEach(function (el) {
      if (!el.value) {
        el.closest(".requestForm__Item").classList.add("error");
        e.preventDefault();
        e.cancelBubble = true;
        e.stopImmediatePropagation();
        e.stopPropagation();
        isProvinceOk = false;
      } else {
        el.closest(".requestForm__Item").classList.remove("error");
      }
    });
  return isProvinceOk;
}
function checkCity(event) {
  var e = event;
  let isCityOk = true;
  document
    .querySelectorAll("#requestConfiguration input[name='request[city]']")
    .forEach(function (el) {
      if (!el.value) {
        el.closest(".requestForm__Item").classList.add("error");
        e.preventDefault();
        e.cancelBubble = true;
        e.stopImmediatePropagation();
        e.stopPropagation();
        isCityOk = false;
      } else {
        el.closest(".requestForm__Item").classList.remove("error");
      }
    });
  return isCityOk;
}
function checkPrivacy(event) {
  var e = event;
  let isChecked = true;
  document
    .querySelectorAll("#requestConfiguration input[name='request[privacy]']")
    .forEach(function (el) {
      if (!el.checked) {
        el.closest(".requestForm__Item").classList.add("error");
        e.preventDefault();
        e.cancelBubble = true;
        e.stopImmediatePropagation();
        e.stopPropagation();
        isChecked = false;
      } else {
        el.closest(".requestForm__Item").classList.remove("error");
      }
    });
  return isChecked;
}
function validateForm(event) {
  let nameOk = checkName(event);
  let lastNameOk = checkLastName(event);
  let emailOk = checkEmail(event);
  let phoneOk = checkPhone(event);
  let countryOk = checkCountry(event);
  let provinceOk = checkProvince(event);
  let cityOk = checkCity(event);
  let privacyOk = checkPrivacy(event);
  if (nameOk && lastNameOk && emailOk && phoneOk && countryOk && provinceOk && cityOk && privacyOk) {
    const form = document.querySelector("#requestConfiguration");
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    submitRequest(form);
  }
}

function submitRequest(form) {
  const url = "https://cipollini.appshop.service.triboo.it/api/orders";
  const data = {
    name: document.querySelector("#requestConfiguration input[name='request[first_name]']").value,
    surname: document.querySelector("#requestConfiguration input[name='request[last_name]']").value,
    email: document.querySelector("#requestConfiguration input[name='request[email]']").value,
    phone: document.querySelector("#requestConfiguration input[name='request[phone]']").value,
    country: document.querySelector("#requestConfiguration input[name='request[country]']").value,
    city: document.querySelector("#requestConfiguration input[name='request[province]']").value,
    street: document.querySelector("#requestConfiguration input[name='request[city]']").value,
    message: document.querySelector("#requestConfiguration textarea[name='request[message]']").value,
    language: document.querySelector("#requestConfiguration input[name='request[language]']").value,
    privacy: document.querySelector("#requestConfiguration input[name='request[privacy]']").checked,
    masterSku: document.querySelector("#requestConfiguration input[name='request[master_sku]']").value,
    variantSku: document.querySelector("#requestConfiguration input[name='request[variant_sku]']").value,
    model: document.querySelector("#requestConfiguration input[name='request[model]']").value,
    design: document.querySelector("#requestConfiguration input[name='request[design]']").value,
    paint: document.querySelector("#requestConfiguration input[name='request[paint]']").value,
    telaio: document.querySelector("#requestConfiguration input[name='request[telaio]']").value,
    stickers: document.querySelector("#requestConfiguration input[name='request[stickers]']").value,
    linee: document.querySelector("#requestConfiguration input[name='request[linee]']").value,
    loghi: document.querySelector("#requestConfiguration input[name='request[loghi]']").value,
    textImage: document.querySelector("#requestConfiguration input[name='request[text-image]']").value,
    configuration: document.querySelector("#requestConfiguration input[name='request[viewer-url]']").value
  };
  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((response) => {
			console.log(response)
      if (response.send) {
        const formSection = document.querySelector(".request-configuration-modal-content");
        const formSectionTitle = document.querySelector(".request-configuration-modal--title-container");
        removePreviousMessage();
				if (formSection) formSection.insertAdjacentHTML(
					"beforebegin",
					`<div class="note form-success">${_suc_mess}</div>`
				);
        form.style.display = "none";
				if (formSectionTitle) formSectionTitle.style.display = "none";
        return;
      }
      return Promise.reject(response);
    })
    .catch((error) => {
      removePreviousMessage();
      form.insertAdjacentHTML(
        "beforebegin",
        `<div class="note form-error">${_err_mess}</div>`
      );
      console.error(error);
    });
}

function removePreviousMessage() {
  if (document.querySelector("#request-configuration-modal .note"))
    document.querySelector("#request-configuration-modal .note").remove();
}
